<template>
  <div
    :class="`notification-more-button tw-items-center tw-flex tw-px-[25px] tw-py-[18px] tw-border border-box ${
      hoverStatus ? 'item-selected' : ''
    }`"
  >
    <avatar
      :img="notification.user.avatar"
      :alt-name="notification.user.name"
    />
    <div
      class="tw-inline-block tw-ml-[15px] tw-text-[13px] tw-text-[#231F20] text-message tw-flex-1"
    >
      <span class="tw-font-medium"
        >{{ notificationData.title
        }}<a
          v-if="notificationData.link"
          :href="notificationData.href"
          class="tw-underline tw-ml-1"
          @click="notificationData.action"
          >{{ notificationData.link }}</a
        ></span
      >
      <br />
      <span class="tw-inline-block">{{ notification.systemActionNotes }}</span>
      <span class="tw-text-[#878787] tw-text-[11px] text-time tw-flex">{{
        getTimeAgo(notification.systemActionDateAdded)
      }}</span>
    </div>
    <UnReadIcon v-if="!notification.systemActionIsRead" class="tw-mr-[15px]" />
    <ButtonShowMore
      :id-popover="'popover-btn-show-more-notification-item-' + index"
      :is-from-notification="true"
      @on-hover="onHover"
    >
      <template #default>
        <CustomDropDownItem
          :style="'normal'"
          :id-text="'app-notification-view-more-option-1'"
        />
        <CustomDropDownItem
          :style="'normal'"
          :id-text="`${
            notification.systemActionIsRead
              ? 'app-notification-mark-as-unread-option-block-1'
              : 'app-notification-mark-as-read-option-block-1'
          }`"
          @click="markAsRead"
        />
        <CustomDropDownItem
          :style="'danger'"
          :id-text="'app-notification-delete-notification-option-block-1'"
          @click="deleteNotification"
        />
      </template>
    </ButtonShowMore>
  </div>
</template>
<script setup lang="ts">
import { getTimeFromNow } from "@/utils/dateTimeUtils";
import { Ref, ref } from "vue";
import avatar from "../common/avatar.vue";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import UnReadIcon from "../svgs/unReadIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
import { SYSTEM_ACTION_TYPE, INDEX_PRIMARY_PAGE } from "@/utils/constants";
import store from "@/store";
const props = defineProps({
  notification: {
    type: Object,
    required: true,
  },
  index: {
    type: [Number, String],
    default: "",
    required: false,
  },
});

let hoverStatus: Ref = ref(false);
const getTimeAgo = (time: string) => {
  return getTimeFromNow(time);
};

const markAsRead = async () => {
  await store.dispatch("Notification/putMakeAsUnreadNotification", {
    actionId: props.notification.systemActionId,
  });
};

const deleteNotification = async () => {
  await store.dispatch("Notification/deleteNotification", {
    actionId: props.notification.systemActionId,
  });
};

const onHover = (value) => {
  hoverStatus.value = value;
};

const getNotificationData = (notification) => {
  switch (notification.typeId) {
    case SYSTEM_ACTION_TYPE.ORG_ACCESS_OFFER:
      return {
        title: getComponentUiText(
          "app-notification-item-title-offer-type-1",
          false,
          {
            orgName: notification.orgToOrgOfferOrg1Name,
          },
        ),
        link: "",
      };

    case SYSTEM_ACTION_TYPE.ORG_ACCESS_REQUEST:
      return {
        title: getComponentUiText(
          "app-notification-item-title-request-type-1",
          false,
          {
            orgName: notification.orgToOrgRequestOrg1Name,
            userOrgName: notification.user.companyName,
          },
        ),
        link: "",
      };

    case SYSTEM_ACTION_TYPE.CHECKLIST_REQUESTED_SUBMIT:
      return {
        title: getComponentUiText(
          "app-notification-item-title-request-submit-type-1",
        ),
        link: getComponentUiText(
          "app-notification-item-title-view-assessment-1",
        ),
        href: notification.checklistRequestedId
          ? `/assess/vendor/review/${notification.checklistRequestedId}`
          : `/assess/vendor/manage`,
        action: () => {
          store.dispatch(
            "Navigation/setPrimaryMenuIndex",
            INDEX_PRIMARY_PAGE.assessmentVendor,
          );
        },
      };

    case SYSTEM_ACTION_TYPE.ORG_ACCESS_REQUEST_PROCESSED:
      return {
        title: getComponentUiText(
          "app-notification-item-title-access-request-processed-type-1",
        ),
        link: getComponentUiText("app-notification-item-title-view-access-1"),
        href: `/settings/organisation/access`,
        action: () => {
          store.dispatch(
            "Navigation/setPrimaryMenuIndex",
            INDEX_PRIMARY_PAGE.setting,
          );
        },
      };

    case SYSTEM_ACTION_TYPE.ORG_ACCESS_OFFER_PROCESSED:
      return {
        title: getComponentUiText(
          "app-notification-item-title-access-offer-processed-type-1",
        ),
        link: getComponentUiText("app-notification-item-title-view-access-1"),
        href: `/settings/organisation/access`,
        action: () => {
          store.dispatch(
            "Navigation/setPrimaryMenuIndex",
            INDEX_PRIMARY_PAGE.setting,
          );
        },
      };

    default:
      return {
        title: getComponentUiText(
          "app-notification-item-title-not-exits-type-1",
          false,
          {
            type: notification?.type,
          },
        ),
      };
  }
};

const notificationData = ref(getNotificationData(props.notification));
</script>
<style scoped lang="scss">
.text-message {
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.text-time {
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
}
.border-box {
  border-bottom: 1px solid var(--ui-rule, #eff0f1);
}
.item-selected {
  background-color: rgba(239, 240, 241, 0.5);
}
</style>
